import type { CSSProperties } from 'react'
import { ColorPicker, Tooltip, type ColorPickerProps } from 'antd'
import { cn } from '@/utils/index.ts'

export type TagColorPickerProps = {
  value?: string
  onChange?: (value: string) => void
  defaultColor: string
  colors: readonly { color: string; label: string }[]
  presets?: ColorPickerProps['presets']
}

export function TagColorPicker({ value, onChange, defaultColor, colors, presets }: TagColorPickerProps) {
  const selectedColor = value ?? defaultColor
  return (
    <div className="flex flex-wrap items-center gap-3">
      <ColorPicker
        defaultFormat="hex"
        disabledAlpha
        format="hex"
        presets={presets}
        showText
        value={selectedColor}
        onChange={(color) => onChange?.(color.toHexString())}
      />
      <div aria-label="预设标签颜色" className="flex flex-wrap items-center gap-2 px-1.5" role="group">
        {colors.map(({ color, label }) => {
          const selected = selectedColor.toLowerCase() === color.toLowerCase()
          return (
            <Tooltip key={color} title={label}>
              <button
                aria-label={`选择${label}`}
                aria-pressed={selected}
                className={cn(
                  'size-6 rounded border border-white bg-[var(--tag-color)] shadow-sm ring-offset-2 transition-transform hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--primary)]',
                  selected && 'shadow-[0_0_0_0.125rem_var(--surface),0_0_0_0.25rem_var(--tag-color)]'
                )}
                onClick={() => onChange?.(color)}
                // 颜色来自表单值，使用 CSS 变量传入不可枚举的运行时值。
                style={{ '--tag-color': color } as CSSProperties}
                type="button"
              />
            </Tooltip>
          )
        })}
      </div>
    </div>
  )
}
